
import { Card } from "@/components/ui/card";
import { ReactNode } from "react";

interface CardContainerProps {
  children: ReactNode;
  onClick: () => void;
  status?: string;
  highlight?: boolean;
}

export const CardContainer = ({ 
  children, 
  onClick, 
  status, 
  highlight = false 
}: CardContainerProps) => {
  const isConfirmed = status === 'confirmed' || status === 'booked';
  
  return (
    <Card
      className={`relative overflow-hidden cursor-pointer bg-white transition-shadow rounded-t-lg rounded-b-lg
        ${highlight ? 'border border-green-200 shadow-md hover:shadow-lg' : 'shadow-md hover:shadow-lg'}`}
      onClick={onClick}
    >
      {isConfirmed && (
        <div className="bg-green-50 p-3 flex items-center justify-center text-center shadow-sm border-b border-green-100">
          <p className="text-green-800 font-medium text-sm">
            {status === 'booked' ? "You're booked in!" : "We're processing your booking"}
          </p>
        </div>
      )}
      <div className={`relative ${isConfirmed ? 'pt-2' : ''}`}>
        {children}
      </div>
    </Card>
  );
};
